import { useContext } from "react";

import debug from "debug";

import type { Config } from "@jti/fe-common/config";
import { getConfig } from "@jti/fe-common/config";

import { ConfigContext } from "./contexts";

const log = debug("desjti:configProvider:useConfig");

export const useConfig = (): Config => {
  try {
    const _config = useContext(ConfigContext);

    if (!_config) {
      throw new Error("useConfig hook used outside of ConfigProvider");
    }
    return _config;
  } catch (error) {
    if (error instanceof Error) {
      log(error.message);
    }
    // the deprecated getConfig function is used here to reduce changes in tests as getConfig is most convenient to mock
    return getConfig();
  }
};
